var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopic4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 77.18 118.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;}.cls-2{fill:url(#radial-gradient);}.cls-3{opacity:0.17;}.cls-4{fill:#320f32;}.cls-5{fill:#673434;}.cls-6{fill:#650a34;}.cls-7{fill:#663614;}.cls-8{fill:#cc9562;}.cls-9{fill:url(#radial-gradient-2);}.cls-10{fill:url(#radial-gradient-3);}.cls-11{fill:url(#radial-gradient-4);}.cls-12{fill:url(#radial-gradient-5);}.cls-13{fill:url(#radial-gradient-6);}.cls-14{fill:url(#radial-gradient-7);}.cls-15{fill:url(#radial-gradient-8);}.cls-16{fill:url(#radial-gradient-9);}.cls-17{fill:url(#radial-gradient-10);}.cls-18{fill:url(#linear-gradient);}.cls-19{fill:url(#linear-gradient-2);}.cls-20{fill:url(#linear-gradient-3);}.cls-21{fill:url(#linear-gradient-4);}.cls-22{fill:url(#linear-gradient-5);}.cls-23{fill:url(#linear-gradient-6);}.cls-24{fill:url(#radial-gradient-11);}.cls-25{fill:url(#radial-gradient-12);}.cls-26{fill:url(#linear-gradient-7);}.cls-27{fill:url(#linear-gradient-8);}.cls-28{fill:url(#linear-gradient-9);}.cls-29{fill:#333;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 38.16,
    cy: -131.45,
    r: 38.34,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f371a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 596.27,
    cy: -2642.83,
    r: 18.65,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, 1484.78, -2252.14)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 609.25,
    cy: -2646.44,
    r: 4.14,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, 1484.78, -2252.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8965f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 340.57,
    cy: -1869.39,
    r: 3.42,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 340.32,
    cy: -1862.02,
    r: 2.27,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 345.72,
    cy: -1879.07,
    r: 2.27,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 62.24,
    cy: -134.98,
    r: 1.09,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 350.51,
    cy: -1879.07,
    r: 1.62,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 350.07,
    cy: -1886.59,
    r: 1.62,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 333.01,
    cy: -1866.59,
    r: 1.62,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 712.1,
    y1: -2759.18,
    x2: 710.97,
    y2: -2760.08,
    gradientTransform: "matrix(0.71, 0.95, 0.71, -0.95, 1486.64, -3248)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8965f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b8863f",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#aa792b",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9f7029",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9a6a28",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976828",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 5955.86,
    y1: 1303.85,
    x2: 5957,
    y2: 1304.76,
    gradientTransform: "matrix(-0.71, -0.95, -0.71, 0.95, 5178.87, 4467.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8965f",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976828",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 603.97,
    y1: -2652.38,
    x2: 609.35,
    y2: -2647,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, 1484.78, -2252.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#c8965f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c69559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b4833a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#a7772b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9e6f29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9a6a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#976828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 707.7,
    y1: -2744.19,
    x2: 706.87,
    y2: -2744.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 5960.25,
    y1: 1288.85,
    x2: 5961.09,
    y2: 1289.51,
    gradientTransform: "matrix(-0.71, -0.95, -0.71, 0.95, 5178.87, 4467.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f371a",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976828",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 596.55,
    y1: -2633.8,
    x2: 600.5,
    y2: -2629.85,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 323.83,
    cy: -1870.63,
    r: 6.99,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 335.74,
    cy: -1878.78,
    r: 5.49,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 702.27,
    y1: -2754.11,
    x2: 699.99,
    y2: -2755.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 5965.71,
    y1: 1298.79,
    x2: 5967.97,
    y2: 1300.6,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 590.49,
    y1: -2645.81,
    x2: 601.21,
    y2: -2635.09,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, 1484.78, -2252.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c8965f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c69559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b4833a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a7772b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9e6f29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9a6a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#976828"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.44,20.35h0a3.62,3.62,0,0,0-1.28-1.27L39.91.48A3.6,3.6,0,0,0,38.15,0h0a3.56,3.56,0,0,0-1.74.48L4.17,19.08a3.57,3.57,0,0,0-1.3,1.29,3.46,3.46,0,0,0-.48,1.77V59.37a3.75,3.75,0,0,0,.48,1.79h0A3.49,3.49,0,0,0,4.2,62.41L36.43,81a3.73,3.73,0,0,0,1.78.47h0A3.43,3.43,0,0,0,39.93,81L72.17,62.42a3.79,3.79,0,0,0,1.29-1.29,3.61,3.61,0,0,0,.47-1.75V22.14A3.73,3.73,0,0,0,73.44,20.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.44,20.35h0a3.62,3.62,0,0,0-1.28-1.27L39.91.48A3.6,3.6,0,0,0,38.15,0h0a3.56,3.56,0,0,0-1.74.48L4.17,19.08a3.57,3.57,0,0,0-1.3,1.29,3.46,3.46,0,0,0-.48,1.77V59.37a3.75,3.75,0,0,0,.48,1.79h0A3.49,3.49,0,0,0,4.2,62.41L36.43,81a3.73,3.73,0,0,0,1.78.47h0A3.43,3.43,0,0,0,39.93,81L72.17,62.42a3.79,3.79,0,0,0,1.29-1.29,3.61,3.61,0,0,0,.47-1.75V22.14A3.73,3.73,0,0,0,73.44,20.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.15,19.08,39.91.48A3.56,3.56,0,0,0,38.14,0h0L24.56,17.22l11.17-1.66a16.09,16.09,0,0,1,4.8,0l32.89,4.81h0A3.65,3.65,0,0,0,72.15,19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.39.48,4.17,19.08a3.57,3.57,0,0,0-1.3,1.29h0L11,40.75l4.13-10.52a16.72,16.72,0,0,1,2.41-4.15L38.15,0h0A3.4,3.4,0,0,0,36.39.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2.39,22.14V59.37a3.75,3.75,0,0,0,.48,1.79h0l21.69,3.17-7-8.9a17.26,17.26,0,0,1-2.4-4.16L2.87,20.37h0A3.46,3.46,0,0,0,2.39,22.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.17,62.41,36.41,81a3.68,3.68,0,0,0,1.78.48h0L51.78,64.28,40.59,65.92a16.16,16.16,0,0,1-4.81,0L2.87,61.12h0A3.43,3.43,0,0,0,4.17,62.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.91,81,72.15,62.41a3.79,3.79,0,0,0,1.29-1.29h0L65.32,40.75,61.17,51.27a16.62,16.62,0,0,1-2.38,4.15L38.15,81.49h0A3.49,3.49,0,0,0,39.91,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.91,81,72.15,62.41a3.71,3.71,0,0,0,1.29-1.29h0L65.32,40.75,61.17,51.27a16.62,16.62,0,0,1-2.38,4.15L38.15,81.49h0A3.49,3.49,0,0,0,39.91,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.91,59.37V22.14a3.74,3.74,0,0,0-.47-1.79h0l-21.7-3.13,7,8.85a16.68,16.68,0,0,1,2.38,4.16L73.44,61.1h0A3.48,3.48,0,0,0,73.91,59.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.18,78.51A3.62,3.62,0,0,1,36.45,78L6.73,60.88a3.28,3.28,0,0,1-1.2-1.14h0l-.07-.08A3.66,3.66,0,0,1,5,57.92V23.59a3.34,3.34,0,0,1,.47-1.72,3.41,3.41,0,0,1,1.27-1.26L36.43,3.46A3.3,3.3,0,0,1,38.13,3h0a3.53,3.53,0,0,1,1.71.46L69.59,20.64a3.42,3.42,0,0,1,1.2,1.16h0l.06.08a3.5,3.5,0,0,1,.46,1.73V57.94a3.44,3.44,0,0,1-1.72,3L39.87,78a3.41,3.41,0,0,1-1.59.46h-.1ZM5.75,59.4l.06.07a3,3,0,0,0,1.11,1.06L36.64,77.69a3.32,3.32,0,0,0,1.48.41h.07a3,3,0,0,0,1.49-.41L69.4,60.54a3.1,3.1,0,0,0,1.53-2.65V23.59a3.23,3.23,0,0,0-.38-1.49l0-.06a3.16,3.16,0,0,0-1.11-1.1L39.68,3.78a3.14,3.14,0,0,0-1.52-.4h0a3.11,3.11,0,0,0-1.52.4L6.92,20.94a3.11,3.11,0,0,0-1.13,1.12,3,3,0,0,0-.42,1.53V57.92A3.32,3.32,0,0,0,5.75,59.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.77,29.52C46.09,20,42,14.22,37.63,14.21h0a23.82,23.82,0,0,0-5.94.75h0l-.08,0a24,24,0,0,0,6,47.3h0a6.05,6.05,0,0,0,3.92-1.64C47.16,55.83,50,41.88,47.77,29.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.77,29.52C46.09,20,42,14.22,37.63,14.21h0A5.39,5.39,0,0,0,35,15h0l0,0a7.9,7.9,0,0,0-1.22.86C28.1,20.64,25.32,34.6,27.49,47c1.68,9.49,5.79,15.31,10.14,15.35h0a6.05,6.05,0,0,0,3.92-1.64C47.16,55.83,50,41.88,47.77,29.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 44.27,
    cy: 49.98,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 54.84,
    cy: 35.34,
    r: 3.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 59.87,
    cy: 29.95,
    r: 2.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 51.63,
    cy: 45.83,
    r: 2.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 62.24,
    cy: 44.28,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 55.02,
    cy: 49.21,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 49.4,
    cy: 54.21,
    r: 1.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 51.48,
    cy: 28.01,
    r: 1.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M37.84,44.41c-.57,0-1.05,2.69-1.05,6s.47,6,1.05,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M37.84,56.42c.58,0,1.06-2.69,1.06-6s-.47-6-1.06-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M42.32,50.43A4.47,4.47,0,0,0,37.85,46h0v8.92a4.46,4.46,0,0,0,4.48-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M45.35,27.61c-.43,0-.77,2-.77,4.41s.34,4.4.77,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M45.35,36.42c.42,0,.77-2,.77-4.4s-.35-4.41-.77-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M48.62,32a3.28,3.28,0,0,0-3.27-3.28V35.3A3.28,3.28,0,0,0,48.62,32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 42.13,
    cy: 24.37,
    r: 6.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 44.78,
    cy: 38.56,
    r: 5.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M34.48,24.31c-1.14,0-2.08,5.36-2.08,12s.94,12,2.08,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M34.48,48.23c1.15,0,2.08-5.35,2.08-12s-.93-12-2.08-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M43.37,36.29a8.89,8.89,0,0,0-8.88-8.88V45.18A8.89,8.89,0,0,0,43.37,36.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0,92.45V85.17c.3-.06.62-.11,1-.15A8.47,8.47,0,0,1,2,85a3.43,3.43,0,0,1,2.27.64,2.54,2.54,0,0,1,.75,2,2.58,2.58,0,0,1-.74,2,3.14,3.14,0,0,1-2.18.67H1.76l-.29,0v2.18Zm2.09-3.36a1.59,1.59,0,0,0,1.1-.33,1.48,1.48,0,0,0,.36-1.11,1.6,1.6,0,0,0-.35-1.14,1.52,1.52,0,0,0-1.09-.35H1.77l-.3,0v2.85l.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M5.68,92.45V84.37H7.13v3.19h.08a1.46,1.46,0,0,1,.53-.49,1.54,1.54,0,0,1,.77-.18,1.5,1.5,0,0,1,.73.19,1.26,1.26,0,0,1,.53.6,2.74,2.74,0,0,1,.2,1.14v3.63H8.52V88.94a.81.81,0,0,0-.17-.59.63.63,0,0,0-.43-.16,1.45,1.45,0,0,0-.28,0,1.43,1.43,0,0,0-.28.13.88.88,0,0,0-.23.24v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M11.87,92.45,10.31,87h1.5l1.35,5.47Zm-.16,2.2.63-2.2.44-1.17L13.87,87h1.45l-2.19,7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M16.9,92.56a4.32,4.32,0,0,1-.73-.06,3.87,3.87,0,0,1-.69-.17V91.17a4.82,4.82,0,0,0,.68.16,4.17,4.17,0,0,0,.71.06,1.06,1.06,0,0,0,.64-.14.49.49,0,0,0,.19-.41.44.44,0,0,0-.11-.32.65.65,0,0,0-.33-.18l-.69-.17a1.7,1.7,0,0,1-.93-.53,1.73,1.73,0,0,1,.24-2.28,2.57,2.57,0,0,1,1.66-.47,6.28,6.28,0,0,1,.64,0,4.65,4.65,0,0,1,.56.1v1.16c-.19,0-.37-.08-.55-.11a5.17,5.17,0,0,0-.57,0,1.71,1.71,0,0,0-.58.08.51.51,0,0,0-.3.21.39.39,0,0,0-.1.27.41.41,0,0,0,.11.3.73.73,0,0,0,.33.16l.7.18a1.68,1.68,0,0,1,.93.52,1.56,1.56,0,0,1,.32,1,1.6,1.6,0,0,1-.57,1.28A2.4,2.4,0,0,1,16.9,92.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M20.3,86.17a1,1,0,0,1-.69-.22.93.93,0,0,1,0-1.2,1.21,1.21,0,0,1,1.39,0A.93.93,0,0,1,21,86,1,1,0,0,1,20.3,86.17Zm-.72,6.28V87H21v5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M24.11,92.56a2.67,2.67,0,0,1-1.31-.3,1.9,1.9,0,0,1-.82-.92,4,4,0,0,1-.29-1.62A3.65,3.65,0,0,1,22,88.08a1.94,1.94,0,0,1,.91-.9,3.09,3.09,0,0,1,1.38-.29,4.07,4.07,0,0,1,.5,0,3.54,3.54,0,0,1,.47.07v1.19l-.35-.05-.35,0a1.6,1.6,0,0,0-.77.16.89.89,0,0,0-.44.49,2.38,2.38,0,0,0-.15.93,2.89,2.89,0,0,0,.14,1,.86.86,0,0,0,.4.5,1.4,1.4,0,0,0,.68.15,1.87,1.87,0,0,0,.4,0l.44-.12v1.2a3.51,3.51,0,0,1-.58.14A3.9,3.9,0,0,1,24.11,92.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M27.09,92.55A1.53,1.53,0,0,1,26,92.13,1.79,1.79,0,0,1,26,89.76a2.5,2.5,0,0,1,1.54-.52l.88-.08.19.86-.9.07a.88.88,0,0,0-.58.22.78.78,0,0,0,0,1,.63.63,0,0,0,.44.15.87.87,0,0,0,.35-.07.82.82,0,0,0,.33-.27V89a1.2,1.2,0,0,0-.1-.55.58.58,0,0,0-.34-.29,1.67,1.67,0,0,0-.61-.09,5,5,0,0,0-.62,0,3.92,3.92,0,0,0-.66.15V87.09a7,7,0,0,1,.77-.15,7.45,7.45,0,0,1,.79,0,3.09,3.09,0,0,1,1.23.21,1.33,1.33,0,0,1,.72.68,2.87,2.87,0,0,1,.23,1.28v3.39H28.5l-.11-.58h-.06a1.24,1.24,0,0,1-.52.52A1.58,1.58,0,0,1,27.09,92.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M30.53,92.45V84.37H32v8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M32.87,90.21V89h2.7v1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M39.6,92.54a4.32,4.32,0,0,1-1.39-.2,2.57,2.57,0,0,1-1-.66,3,3,0,0,1-.65-1.16,6,6,0,0,1-.23-1.75,5,5,0,0,1,.41-2.18,2.66,2.66,0,0,1,1.17-1.24A4,4,0,0,1,39.7,85c.24,0,.47,0,.7,0a4.67,4.67,0,0,1,.67.13v1.25l-.62-.12a4.44,4.44,0,0,0-.63,0,2.25,2.25,0,0,0-1.09.24,1.52,1.52,0,0,0-.67.79,4.1,4.1,0,0,0-.22,1.5,4.22,4.22,0,0,0,.22,1.54,1.44,1.44,0,0,0,.66.78,2.35,2.35,0,0,0,1.09.23,3.11,3.11,0,0,0,.59-.06,4.8,4.8,0,0,0,.67-.18v1.26a3.55,3.55,0,0,1-.68.17A5.16,5.16,0,0,1,39.6,92.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M41.63,92.45V84.37h1.46v3.19h.07a1.46,1.46,0,0,1,.53-.49,1.57,1.57,0,0,1,.77-.18,1.5,1.5,0,0,1,.73.19,1.26,1.26,0,0,1,.53.6,2.59,2.59,0,0,1,.2,1.14v3.63H44.47V88.94a.81.81,0,0,0-.17-.59.61.61,0,0,0-.43-.16,1.45,1.45,0,0,0-.28,0,1.66,1.66,0,0,0-.27.13.76.76,0,0,0-.23.24v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M49.18,92.56a3.42,3.42,0,0,1-1.5-.29,1.8,1.8,0,0,1-.85-.93,4.22,4.22,0,0,1-.28-1.65,3.91,3.91,0,0,1,.27-1.55,1.94,1.94,0,0,1,.76-.94,2.27,2.27,0,0,1,1.19-.31,1.93,1.93,0,0,1,1.13.32,1.9,1.9,0,0,1,.7.94,4.75,4.75,0,0,1,.23,1.58v.43H47.62v-.89h2.06l-.21.09a4.38,4.38,0,0,0-.08-.93.74.74,0,0,0-.24-.45.6.6,0,0,0-.38-.12.68.68,0,0,0-.4.12.8.8,0,0,0-.25.45,3.72,3.72,0,0,0-.09.93V90a2.29,2.29,0,0,0,.13.83.74.74,0,0,0,.41.42,1.94,1.94,0,0,0,.79.13,4,4,0,0,0,.59,0,5.76,5.76,0,0,0,.62-.13v1.17c-.25.06-.49.11-.71.14A5.06,5.06,0,0,1,49.18,92.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M51.44,92.45V87h1.21l.11.58h.06a1.7,1.7,0,0,1,1.37-.67,1.48,1.48,0,0,1,.72.18,1.24,1.24,0,0,1,.52.58,2.73,2.73,0,0,1,.19,1.09v3.71H54.19V88.91a.81.81,0,0,0-.15-.57.58.58,0,0,0-.41-.15.82.82,0,0,0-.26,0,1.1,1.1,0,0,0-.26.14.85.85,0,0,0-.22.24v3.84Zm5.47,0V88.91a.76.76,0,0,0-.17-.57.6.6,0,0,0-.42-.15.87.87,0,0,0-.26,0,1.28,1.28,0,0,0-.28.15.83.83,0,0,0-.23.26l-.26-.9A1.82,1.82,0,0,1,56,87.1a1.8,1.8,0,0,1,.84-.21,1.67,1.67,0,0,1,.78.19,1.26,1.26,0,0,1,.56.6,2.67,2.67,0,0,1,.2,1.15v3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M59.94,86.17a.94.94,0,0,1-.69-.22.93.93,0,0,1,0-1.2.94.94,0,0,1,.69-.22,1,1,0,0,1,.7.22.93.93,0,0,1,0,1.2A1,1,0,0,1,59.94,86.17Zm-.73,6.28V87h1.46v5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M62.85,92.56a4.52,4.52,0,0,1-.74-.06,4,4,0,0,1-.68-.17V91.17a5,5,0,0,0,.67.16,4.37,4.37,0,0,0,.72.06,1.06,1.06,0,0,0,.64-.14.52.52,0,0,0,.19-.41.44.44,0,0,0-.11-.32.65.65,0,0,0-.33-.18l-.69-.17a1.7,1.7,0,0,1-.93-.53,1.51,1.51,0,0,1-.32-1,1.57,1.57,0,0,1,.56-1.25,2.57,2.57,0,0,1,1.66-.47,6.28,6.28,0,0,1,.64,0,4.48,4.48,0,0,1,.55.1v1.16a3.79,3.79,0,0,0-1.12-.14,1.8,1.8,0,0,0-.58.08.58.58,0,0,0-.3.21.44.44,0,0,0-.09.27.41.41,0,0,0,.11.3.74.74,0,0,0,.32.16l.7.18a1.71,1.71,0,0,1,.94.52,1.79,1.79,0,0,1-.26,2.32A2.39,2.39,0,0,1,62.85,92.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M65,88.13V87h3.5v1.15Zm2.65,4.41a1.91,1.91,0,0,1-1.37-.46,2.07,2.07,0,0,1-.49-1.54V87L66,85.05h1.19v5.32a1.08,1.08,0,0,0,.18.72.74.74,0,0,0,.6.2h.24l.26,0v1.2l-.41.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M69,92.45V87h1.2l.11.76h.07a1.31,1.31,0,0,1,.54-.65,1.55,1.55,0,0,1,.75-.19h.2l.17,0v1.35l-.23,0h-.24a1.67,1.67,0,0,0-.44.06,1.41,1.41,0,0,0-.39.19.93.93,0,0,0-.28.28v3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M73.73,92.45,72.18,87h1.5L75,92.45Zm-.16,2.2.63-2.2.44-1.17L75.73,87h1.45L75,94.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M6.17,104.56a2.45,2.45,0,0,1-1.24-.3,1.88,1.88,0,0,1-.78-.92,4,4,0,0,1-.27-1.6,4.15,4.15,0,0,1,.27-1.62,1.91,1.91,0,0,1,.78-.93,2.4,2.4,0,0,1,1.24-.3,2.44,2.44,0,0,1,1.23.31,1.91,1.91,0,0,1,.78.93,4.91,4.91,0,0,1,0,3.21,1.88,1.88,0,0,1-.78.92A2.39,2.39,0,0,1,6.17,104.56Zm0-1.1a.66.66,0,0,0,.42-.14.9.9,0,0,0,.28-.5A4.82,4.82,0,0,0,7,101.75a4.41,4.41,0,0,0-.1-1.1.91.91,0,0,0-.27-.52.68.68,0,0,0-.42-.14.69.69,0,0,0-.43.14.87.87,0,0,0-.27.51,5.94,5.94,0,0,0,0,2.17.87.87,0,0,0,.27.51A.67.67,0,0,0,6.17,103.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M8.53,100.13V99H12v1.15Zm.79,4.32v-6a2.58,2.58,0,0,1,.24-1.16,1.63,1.63,0,0,1,.73-.74,2.63,2.63,0,0,1,1.22-.25h.35l.34,0v1.17l-.24,0h-.24a1.09,1.09,0,0,0-.74.21.92.92,0,0,0-.23.68v6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.44,104.45v-7.4h1.48l3,5.38h-.25V97.05H20v7.4H18.55l-3-5.38h.25v5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M22.24,104.55a1.49,1.49,0,0,1-1.1-.42,1.53,1.53,0,0,1-.43-1.15,1.57,1.57,0,0,1,.48-1.22,2.5,2.5,0,0,1,1.54-.52l.88-.08.2.86-.91.07a.83.83,0,0,0-.57.22.65.65,0,0,0-.19.5.68.68,0,0,0,.16.5.64.64,0,0,0,.45.15.86.86,0,0,0,.34-.07.82.82,0,0,0,.33-.27V101a1.2,1.2,0,0,0-.1-.55.59.59,0,0,0-.33-.29,1.75,1.75,0,0,0-.61-.09,4.69,4.69,0,0,0-.62,0,3.52,3.52,0,0,0-.66.15V99.09a6.82,6.82,0,0,1,.76-.15,7.63,7.63,0,0,1,.8,0,3.16,3.16,0,0,1,1.23.21,1.35,1.35,0,0,1,.71.68,2.86,2.86,0,0,1,.24,1.28v3.39H23.65l-.11-.58h-.06a1.19,1.19,0,0,1-.52.52A1.58,1.58,0,0,1,22.24,104.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M25.69,104.45V99H26.9l.11.58h.06a1.68,1.68,0,0,1,.6-.5,1.77,1.77,0,0,1,.77-.17,1.67,1.67,0,0,1,.78.19,1.2,1.2,0,0,1,.55.6,2.56,2.56,0,0,1,.21,1.13v3.64H28.52v-3.54a.79.79,0,0,0-.16-.57.63.63,0,0,0-.44-.15,1,1,0,0,0-.28,0,1.13,1.13,0,0,0-.27.13.88.88,0,0,0-.23.24v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M32.89,104.56a2.39,2.39,0,0,1-1.23-.3,1.88,1.88,0,0,1-.78-.92,4,4,0,0,1-.27-1.6,4.15,4.15,0,0,1,.27-1.62,1.91,1.91,0,0,1,.78-.93,2.63,2.63,0,0,1,2.46,0,1.91,1.91,0,0,1,.78.93,4.91,4.91,0,0,1,0,3.21,1.88,1.88,0,0,1-.78.92A2.39,2.39,0,0,1,32.89,104.56Zm0-1.1a.69.69,0,0,0,.43-.14.84.84,0,0,0,.27-.5,4.82,4.82,0,0,0,.09-1.07,5.06,5.06,0,0,0-.09-1.1,1,1,0,0,0-.28-.52.64.64,0,0,0-.42-.14.71.71,0,0,0-.43.14,1,1,0,0,0-.27.51,6.59,6.59,0,0,0,0,2.17,1,1,0,0,0,.27.51A.69.69,0,0,0,32.89,103.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M35.84,104.45V99h1.21l.11.58h.06a1.66,1.66,0,0,1,1.37-.67,1.48,1.48,0,0,1,.72.18,1.22,1.22,0,0,1,.51.58,2.56,2.56,0,0,1,.2,1.09v3.71H38.59v-3.54a.76.76,0,0,0-.16-.57.55.55,0,0,0-.4-.15.82.82,0,0,0-.26,0,.94.94,0,0,0-.26.14.73.73,0,0,0-.22.24v3.84Zm5.47,0v-3.54a.76.76,0,0,0-.17-.57.6.6,0,0,0-.42-.15.82.82,0,0,0-.26,0,1.08,1.08,0,0,0-.28.15.83.83,0,0,0-.23.26l-.26-.9a1.73,1.73,0,0,1,.68-.64,1.87,1.87,0,0,1,.85-.21,1.73,1.73,0,0,1,.78.19,1.31,1.31,0,0,1,.56.6,2.83,2.83,0,0,1,.2,1.15v3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M44.88,104.55a1.5,1.5,0,0,1-1.11-.42,1.8,1.8,0,0,1,0-2.37,2.53,2.53,0,0,1,1.55-.52l.87-.08.2.86-.91.07a.87.87,0,0,0-.57.22.65.65,0,0,0-.19.5.69.69,0,0,0,.17.5.63.63,0,0,0,.44.15.91.91,0,0,0,.35-.07.82.82,0,0,0,.33-.27V101a1.19,1.19,0,0,0-.11-.55.53.53,0,0,0-.33-.29,1.71,1.71,0,0,0-.61-.09,5,5,0,0,0-.62,0,3.92,3.92,0,0,0-.66.15V99.09a7,7,0,0,1,.77-.15,7.45,7.45,0,0,1,.79,0,3.09,3.09,0,0,1,1.23.21,1.4,1.4,0,0,1,.72.68,3,3,0,0,1,.23,1.28v3.39H46.29l-.11-.58h-.07a1.14,1.14,0,0,1-.52.52A1.51,1.51,0,0,1,44.88,104.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M47.83,100.13V99h3.5v1.15Zm2.65,4.41a1.89,1.89,0,0,1-1.37-.46,2,2,0,0,1-.49-1.54V99l.27-1.93h1.19v5.32a1.15,1.15,0,0,0,.17.72.76.76,0,0,0,.61.2h.23l.27,0v1.2l-.41.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M54.23,104.56a3.42,3.42,0,0,1-1.5-.29,1.76,1.76,0,0,1-.85-.93,4,4,0,0,1-.28-1.65,4.11,4.11,0,0,1,.26-1.55,2,2,0,0,1,.76-.94,2.33,2.33,0,0,1,1.2-.31,2,2,0,0,1,1.13.32,1.89,1.89,0,0,1,.69.94,4.49,4.49,0,0,1,.24,1.58v.43H52.67v-.89h2.06l-.21.09a4.38,4.38,0,0,0-.08-.93.86.86,0,0,0-.24-.45.62.62,0,0,0-.38-.12.65.65,0,0,0-.4.12.8.8,0,0,0-.25.45,3.72,3.72,0,0,0-.09.93V102a2.09,2.09,0,0,0,.13.83.74.74,0,0,0,.41.42,1.94,1.94,0,0,0,.79.13,3.79,3.79,0,0,0,.58,0,5.44,5.44,0,0,0,.63-.13v1.17c-.26.06-.49.11-.71.14A5.06,5.06,0,0,1,54.23,104.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M56.49,104.45V99h1.19l.12.76h.07a1.3,1.3,0,0,1,.53-.65,1.58,1.58,0,0,1,.75-.19h.2l.17,0v1.35l-.23,0h-.23a1.61,1.61,0,0,0-.44.06,1.34,1.34,0,0,0-.4.19,1.07,1.07,0,0,0-.28.28v3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M60.76,98.17a.94.94,0,0,1-.69-.22.93.93,0,0,1,0-1.2.94.94,0,0,1,.69-.22.92.92,0,0,1,.69.22.9.9,0,0,1,0,1.2A.92.92,0,0,1,60.76,98.17ZM60,104.45V99h1.46v5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M63.64,104.55a1.5,1.5,0,0,1-1.11-.42,1.8,1.8,0,0,1,0-2.37,2.53,2.53,0,0,1,1.55-.52l.87-.08.2.86-.91.07a.87.87,0,0,0-.57.22.65.65,0,0,0-.19.5.69.69,0,0,0,.17.5.62.62,0,0,0,.44.15.91.91,0,0,0,.35-.07.82.82,0,0,0,.33-.27V101a1.19,1.19,0,0,0-.11-.55.56.56,0,0,0-.33-.29,1.71,1.71,0,0,0-.61-.09,4.82,4.82,0,0,0-.62,0,3.52,3.52,0,0,0-.66.15V99.09a7,7,0,0,1,.77-.15,7.45,7.45,0,0,1,.79,0,3.09,3.09,0,0,1,1.23.21,1.4,1.4,0,0,1,.72.68,3,3,0,0,1,.23,1.28v3.39H65.05l-.11-.58h-.07a1.14,1.14,0,0,1-.52.52A1.51,1.51,0,0,1,63.64,104.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M67.08,104.45V96.37h1.46v8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M70.71,104.56a4.32,4.32,0,0,1-.73-.06,3.87,3.87,0,0,1-.69-.17v-1.16a4.82,4.82,0,0,0,.68.16,4.17,4.17,0,0,0,.71.06,1.06,1.06,0,0,0,.64-.14.49.49,0,0,0,.19-.41.4.4,0,0,0-.11-.32.66.66,0,0,0-.32-.18l-.7-.17a1.7,1.7,0,0,1-.93-.53,1.57,1.57,0,0,1-.32-1,1.55,1.55,0,0,1,.57-1.25,2.52,2.52,0,0,1,1.65-.47,6.28,6.28,0,0,1,.64,0,4.65,4.65,0,0,1,.56.1v1.16c-.19,0-.37-.08-.55-.11a5,5,0,0,0-.57,0,1.75,1.75,0,0,0-.58.08.58.58,0,0,0-.3.21.44.44,0,0,0-.09.27.4.4,0,0,0,.1.3.73.73,0,0,0,.33.16l.7.18a1.75,1.75,0,0,1,.94.52,1.61,1.61,0,0,1,.31,1,1.57,1.57,0,0,1-.57,1.28A2.4,2.4,0,0,1,70.71,104.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M3.58,116.55a1.49,1.49,0,0,1-1.1-.42A1.53,1.53,0,0,1,2.05,115a1.57,1.57,0,0,1,.48-1.22,2.5,2.5,0,0,1,1.54-.52l.88-.08.2.86-.91.07a.83.83,0,0,0-.57.22.65.65,0,0,0-.19.5.68.68,0,0,0,.16.5.63.63,0,0,0,.44.15.87.87,0,0,0,.35-.07.82.82,0,0,0,.33-.27V113a1.2,1.2,0,0,0-.1-.55.59.59,0,0,0-.33-.29,1.75,1.75,0,0,0-.61-.09,4.69,4.69,0,0,0-.62,0,3.52,3.52,0,0,0-.66.15v-1.17a6.82,6.82,0,0,1,.76-.15,7.63,7.63,0,0,1,.8,0,3.16,3.16,0,0,1,1.23.21,1.35,1.35,0,0,1,.71.68,2.86,2.86,0,0,1,.24,1.28v3.39H5l-.11-.58H4.82a1.19,1.19,0,0,1-.52.52A1.58,1.58,0,0,1,3.58,116.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M7,116.45V111H8.24l.11.58h.06a1.68,1.68,0,0,1,.6-.5,1.77,1.77,0,0,1,.77-.17,1.67,1.67,0,0,1,.78.19,1.25,1.25,0,0,1,.55.6,2.56,2.56,0,0,1,.21,1.13v3.64H9.86v-3.54a.79.79,0,0,0-.16-.57.65.65,0,0,0-.44-.15,1,1,0,0,0-.28,0,1.13,1.13,0,0,0-.27.13.76.76,0,0,0-.23.24v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M13.85,116.56a1.74,1.74,0,0,1-.93-.28,1.83,1.83,0,0,1-.71-.88,4.77,4.77,0,0,1,0-3.19,2,2,0,0,1,.89-1,3.24,3.24,0,0,1,1.55-.33H15v-2.54h1.46v8.08H15.19l-.1-.58H15a1.18,1.18,0,0,1-.45.49A1.29,1.29,0,0,1,13.85,116.56Zm.47-1.24a.78.78,0,0,0,.36-.08A.69.69,0,0,0,15,115v-3l-.2,0h-.19a1,1,0,0,0-.85.36,2.2,2.2,0,0,0-.29,1.31,3.29,3.29,0,0,0,.12,1,.81.81,0,0,0,.32.48A.77.77,0,0,0,14.32,115.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M19.42,116.45v-7.4h1.49l3,5.38h-.26v-5.38H25v7.4H23.54l-3-5.38h.25v5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M27.23,116.55a1.53,1.53,0,0,1-1.11-.42A1.56,1.56,0,0,1,25.7,115a1.6,1.6,0,0,1,.47-1.22,2.56,2.56,0,0,1,1.55-.52l.87-.08.2.86-.91.07a.87.87,0,0,0-.57.22.78.78,0,0,0,0,1,.63.63,0,0,0,.44.15.91.91,0,0,0,.35-.07.82.82,0,0,0,.33-.27V113a1.2,1.2,0,0,0-.1-.55.58.58,0,0,0-.34-.29,1.65,1.65,0,0,0-.6-.09,4.69,4.69,0,0,0-.62,0,3.82,3.82,0,0,0-.67.15v-1.17a7,7,0,0,1,.77-.15,7.45,7.45,0,0,1,.79,0,3.18,3.18,0,0,1,1.24.21,1.35,1.35,0,0,1,.71.68,2.86,2.86,0,0,1,.24,1.28v3.39H28.64l-.11-.58h-.07a1.17,1.17,0,0,1-.51.52A1.58,1.58,0,0,1,27.23,116.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M30.67,116.45V111h1.21l.12.58h.06a1.68,1.68,0,0,1,.6-.5,1.77,1.77,0,0,1,.77-.17,1.67,1.67,0,0,1,.78.19,1.25,1.25,0,0,1,.55.6,2.57,2.57,0,0,1,.2,1.13v3.64H33.51v-3.54a.75.75,0,0,0-.17-.57.61.61,0,0,0-.43-.15,1,1,0,0,0-.28,0,1.43,1.43,0,0,0-.28.13.85.85,0,0,0-.22.24v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M37.88,116.56a2.39,2.39,0,0,1-1.23-.3,1.9,1.9,0,0,1-.79-.92,4,4,0,0,1-.27-1.6,4.15,4.15,0,0,1,.27-1.62,1.91,1.91,0,0,1,.78-.93,2.42,2.42,0,0,1,1.24-.3,2.39,2.39,0,0,1,1.23.31,1.91,1.91,0,0,1,.78.93,4.91,4.91,0,0,1,0,3.21,1.88,1.88,0,0,1-.78.92A2.39,2.39,0,0,1,37.88,116.56Zm0-1.1a.69.69,0,0,0,.43-.14.9.9,0,0,0,.27-.5,4.82,4.82,0,0,0,.09-1.07,4.41,4.41,0,0,0-.1-1.1.91.91,0,0,0-.27-.52.68.68,0,0,0-.42-.14.69.69,0,0,0-.43.14.87.87,0,0,0-.27.51,5.94,5.94,0,0,0,0,2.17.87.87,0,0,0,.27.51A.69.69,0,0,0,37.88,115.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M43.09,116.56a2.67,2.67,0,0,1-1.31-.3,1.9,1.9,0,0,1-.82-.92,4,4,0,0,1-.29-1.62,3.65,3.65,0,0,1,.32-1.64,2,2,0,0,1,.9-.9,3.16,3.16,0,0,1,1.39-.29,4.07,4.07,0,0,1,.5,0,3.54,3.54,0,0,1,.47.07v1.19l-.36-.05-.34,0a1.6,1.6,0,0,0-.77.16.89.89,0,0,0-.44.49,2.38,2.38,0,0,0-.15.93,2.89,2.89,0,0,0,.14,1,.86.86,0,0,0,.4.5,1.4,1.4,0,0,0,.68.15,1.87,1.87,0,0,0,.4,0l.44-.12v1.2a3.28,3.28,0,0,1-.58.14A3.9,3.9,0,0,1,43.09,116.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M46.07,116.55a1.53,1.53,0,0,1-1.11-.42,1.56,1.56,0,0,1-.42-1.15,1.6,1.6,0,0,1,.47-1.22,2.56,2.56,0,0,1,1.55-.52l.87-.08.2.86-.91.07a.87.87,0,0,0-.57.22.78.78,0,0,0,0,1,.63.63,0,0,0,.44.15.91.91,0,0,0,.35-.07.82.82,0,0,0,.33-.27V113a1.35,1.35,0,0,0-.1-.55.58.58,0,0,0-.34-.29,1.67,1.67,0,0,0-.61-.09,5,5,0,0,0-.62,0,3.92,3.92,0,0,0-.66.15v-1.17a7,7,0,0,1,.77-.15,7.45,7.45,0,0,1,.79,0,3.09,3.09,0,0,1,1.23.21,1.33,1.33,0,0,1,.72.68,2.87,2.87,0,0,1,.23,1.28v3.39H47.48l-.11-.58H47.3a1.17,1.17,0,0,1-.51.52A1.58,1.58,0,0,1,46.07,116.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M49,112.13V111h3.5v1.15Zm2.65,4.41a1.91,1.91,0,0,1-1.37-.46,2.07,2.07,0,0,1-.49-1.54V111l.27-1.93h1.19v5.32a1.08,1.08,0,0,0,.18.72.75.75,0,0,0,.6.2h.24l.26,0v1.2l-.41.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M54.33,116.55a1.53,1.53,0,0,1-1.11-.42A1.56,1.56,0,0,1,52.8,115a1.6,1.6,0,0,1,.47-1.22,2.56,2.56,0,0,1,1.55-.52l.87-.08.2.86-.91.07a.87.87,0,0,0-.57.22.78.78,0,0,0,0,1,.63.63,0,0,0,.44.15.91.91,0,0,0,.35-.07.82.82,0,0,0,.33-.27V113a1.35,1.35,0,0,0-.1-.55.58.58,0,0,0-.34-.29,1.67,1.67,0,0,0-.61-.09,5,5,0,0,0-.62,0,3.92,3.92,0,0,0-.66.15v-1.17a7,7,0,0,1,.77-.15,7.45,7.45,0,0,1,.79,0,3.09,3.09,0,0,1,1.23.21,1.33,1.33,0,0,1,.72.68,2.87,2.87,0,0,1,.23,1.28v3.39H55.74l-.11-.58h-.07a1.17,1.17,0,0,1-.51.52A1.58,1.58,0,0,1,54.33,116.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M57.77,116.45v-8.08h1.46v8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M61.16,116.45,59.6,111h1.5l1.35,5.47Zm-.17,2.2.64-2.2.44-1.17,1.09-4.3h1.45l-2.19,7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M66.19,116.56a4.52,4.52,0,0,1-.74-.06,4,4,0,0,1-.68-.17v-1.16a5,5,0,0,0,.67.16,4.37,4.37,0,0,0,.72.06,1.06,1.06,0,0,0,.64-.14.52.52,0,0,0,.19-.41.44.44,0,0,0-.11-.32.65.65,0,0,0-.33-.18l-.69-.17a1.7,1.7,0,0,1-.93-.53,1.51,1.51,0,0,1-.32-1,1.57,1.57,0,0,1,.56-1.25,2.57,2.57,0,0,1,1.66-.47,6.28,6.28,0,0,1,.64,0,4.16,4.16,0,0,1,.55.1v1.16a3.79,3.79,0,0,0-1.12-.14,1.8,1.8,0,0,0-.58.08.58.58,0,0,0-.3.21.44.44,0,0,0-.09.27.41.41,0,0,0,.11.3.74.74,0,0,0,.32.16l.7.18a1.71,1.71,0,0,1,.94.52,1.79,1.79,0,0,1-.26,2.32A2.37,2.37,0,0,1,66.19,116.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M69.59,110.17a.94.94,0,0,1-.69-.22.93.93,0,0,1,0-1.2.94.94,0,0,1,.69-.22,1,1,0,0,1,.7.22.93.93,0,0,1,0,1.2A1,1,0,0,1,69.59,110.17Zm-.73,6.28V111h1.46v5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M72.5,116.56a4.52,4.52,0,0,1-.74-.06,4,4,0,0,1-.68-.17v-1.16a4.68,4.68,0,0,0,.67.16,4.37,4.37,0,0,0,.72.06,1.06,1.06,0,0,0,.64-.14.52.52,0,0,0,.19-.41.44.44,0,0,0-.11-.32.65.65,0,0,0-.33-.18l-.69-.17a1.7,1.7,0,0,1-.93-.53,1.51,1.51,0,0,1-.32-1,1.57,1.57,0,0,1,.56-1.25,2.57,2.57,0,0,1,1.66-.47,6.28,6.28,0,0,1,.64,0,4.48,4.48,0,0,1,.55.1v1.16a3.79,3.79,0,0,0-1.12-.14,1.8,1.8,0,0,0-.58.08.58.58,0,0,0-.3.21.44.44,0,0,0-.09.27.41.41,0,0,0,.11.3.74.74,0,0,0,.32.16l.7.18a1.71,1.71,0,0,1,.94.52,1.79,1.79,0,0,1-.26,2.32A2.37,2.37,0,0,1,72.5,116.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic4);
export default __webpack_public_path__ + "static/media/topic_4.fb54745230bc5d2ace8ede2c7b56fe7f.svg";
export { ForwardRef as ReactComponent };